import React from "react"
import {Card, Container, Row, Col, Dropdown, Badge, Button} from 'react-bootstrap' 
import CreateLineItem from "../../CreateLineItem"
import FlightPlanStatus from '../admin_components/FlightPlanStatus';

export default class JobDescriptionCard extends React.Component {

  constructor(props) {
    super(props)

    this.tally_icon_path = props.tally_icon_path
    this.hc_icon_path = props.hc_icon_path
    this.difference_icon_path = props.difference_icon_path
    this.pens_icon_path = props.pens_icon_path
    this.images_icon_path = props.images_icon_path
    this.upload_images_icon_path = props.upload_images_icon_path

    this.feedlot_id = props.feedlot_id
    this.job_id = props.job_id
    this.is_admin = props.is_admin || false
    
    this.state = {
      job: null
    }

    this.getJob = this.getJob.bind(this)
    this.listener = this.subscribe()

    this.uploadCSV = this.uploadCSV.bind(this)
    this.createPen = this.createPen.bind(this)
    this.editName = this.editName.bind(this)
    this.setArchive = this.setArchive.bind(this)
  }

  componentDidUpdate() {
    $('[data-toggle="tooltip"]').tooltip()
  }

  render () {
    try {
      var job = this.state.job
      if(job == null) {
        return null
      }

      var is_admin = this.is_admin
      var job_path = Routes.custom_counting_job_path(this.job_id)
      var feedlot_path = Routes.feedlot_path(this.feedlot_id)

      return (
        <Card>
          <Card.Header>
            <Container fluid className="pl-0">
              <Row className="pr-4">
                <Col className="p-0">
                  <Card.Title style={{minWidth: "max-content", display: "block"}} className="m-0">
                    <div>
                      <a href={job_path} style={{color: "inherit"}}>{`Custom Job: ${job.name}`}</a>
                    </div>
                    
                    <div className="m-0" style={{fontSize: "0.7em"}}>
                      <a href={feedlot_path} style={{color: "inherit"}}>{`Feedlot: ${job.feedlot_name}`}</a>
                    </div>
                  </Card.Title>
                </Col>
                <Col xs="auto" className="p-0">
                  <span className="label">
                    Created At:
                  </span>
                  <span className="field"> 
                    {job.created_at}
                  </span>
                </Col>
              </Row>
              <Row className="row-gap-1 justify-content-end" >
                <Col xs="auto" className="p-0">
                  <div className="nowrap">
                    <div data-tip data-for="upload-images-tooltip" className="d-inline-block">
                      <button id="upload-images-btn" className={"btn btn-primary fa txt-lg py-1 px-2"}
                        onClick={() => this.importPhotos()}>
                        <img src={this.upload_images_icon_path} className="scale" style={{filter: "invert(100%)"}}/>
                      </button>
                    </div>
                    <ReactTooltip id='upload-images-tooltip' effect='solid' 
                      textColor="black">
                      <span>Upload Images</span>
                    </ReactTooltip>

                    <div data-tip data-for="export-csv-tooltip" className="d-inline-block">
                      <a id="export-pen-data-btn" className={"btn btn-primary fas fa-file-download m-1 txt-lg py-1 px-2"}
                        href={Routes.export_csv_custom_counting_job_path(this.job_id)}
                        data-method="post"/>
                    </div>
                    <ReactTooltip id='export-csv-tooltip' effect='solid' 
                      textColor="black">
                      <span>Download CSV Count Info</span>
                    </ReactTooltip>
                  </div>
                </Col>
              </Row>
            </Container>
            <Dropdown>
              <Dropdown.Toggle 
                as="i" 
                className="btn-icon fas fa-ellipsis-v dropdown-no-arrow"
                bsPrefix=""
                style={{fontSize: "1.5em"}}>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={this.editName}>
                  Edit Job Name
                </Dropdown.Item>
                 
                <Dropdown.Item onClick={this.createPen}>
                  Create Pen
                </Dropdown.Item>
                {job.archived == false &&
                  <Dropdown.Item 
                  className="text-danger"
                  onClick={this.setArchive}>
                  Archive
                  </Dropdown.Item>
                }
              </Dropdown.Menu>
            </Dropdown>
          </Card.Header>
          <Card.Body style={{height: "auto"}}>
            {this.generateClientView()}
          </Card.Body>
        </Card>
      )
    } catch (error) {
      console.log(error)
      Sentry.captureException(error)
      return null
    }
  }

  generateClientView() {

    var job = this.state.job
    if(job == null) {
      return null
    }

    return (
      <Container fluid id="pen-list-component">
        <Row className="row-gap-3 txt-lg justify-content-around">
          <Col xs={6} md={4} lg="auto">
            <div className="w-100 text-center txt-xlg" >
              <img src={this.hc_icon_path} className="pr-2" style={{height: "1em", verticalAlign: "middle"}}/>
              <span style={{verticalAlign: "middle"}}>
                {numberWithCommas(job.count || 0)}
              </span>
            </div>
            <div className="w-100 text-center" style={{fontWeight: "bold"}}>
              Count
            </div>
          </Col>
        </Row>
      </Container>
    )
  }

  subscribe() {
    var _this = this
    return App.cable.subscriptions.create(
      {
        channel: "CustomCountingChannels::JobDescriptionCardChannel",
        feedlot_id: this.feedlot_id,
        job_id: this.job_id
      },
      {  
        connected() {
          _this.getJob()
        },

        received(data) {
          if (data.job != null) {
            _this.setState({
              job: data.job
            })
          } else if(data.message == "job_updated") {
            _this.getJob()
          }
        }
      }
    )
  }

  getJob() {
    this.listener.perform("get_job")
  }


  uploadCSV() {
    $('#upload-csv-modal').modal('show')
  }

  createPen() {
    postal.publish({
      channel: "EditJobModal",
      topic: "open",
      data: {
        job_id: this.job_id,
        type: "create_pen"
      }
    })
  }

  editName() {
    postal.publish({
      channel: "EditJobModal",
      topic: "open",
      data: {
        job_id: this.job_id,
        type: "edit_name"
      }
    })
  }

  editPasses() {
    postal.publish({
      channel: "EditJobModal",
      topic: "open",
      data: {
        job_id: this.job_id,
        type: "edit_passes"
      }
    })
  }

  setArchive(bool_value) { 
    if (ask("Are You Sure You Want To Archive This Job?")) {
      var jform = new FormData();
      jform.append('utf8',"&#x2713;");
      jform.append('authenticity_token',form_authenticity_token());
      jform.append('value', bool_value);
      
      $.ajax({
        url: Routes.archive_custom_counting_job_path(this.job_id),
        type: "POST",
        data: jform,
        dataType: 'json',
        mimeType: 'multipart/form-data',
        contentType: false,
        cache: false,
        processData: false,
        success: function(response) {
          if (response.status == "Success") {
            postAlert("success", `Successfully Archived Job`)
            window.location.reload()
          } else {
            postAlert("danger", `Failed To Archive Job`)
          }
        },
        error: function(request, textStatus, errorThrown) {
          postAlert("danger", `Failed To Archive Job`)
        },
        complete: function() {}
      })
    }
  }

  importPhotos() {
    postal.publish({
      channel: "ImportPhotos",
      topic: "open",
      data: {
        job_id: this.job_id
      }
    })
  }
}